export default "__VITE_ASSET__97ad6511__"